module.exports = __webpack_public_path__ + "img/horizontal_7_1_3016.2d47fd64.png";